import { cn } from "@/utils/cn";
import type { HTMLAttributes } from "react";

interface Props {
  title: string;
  lead?: string;
  showDivider?: boolean;
  noMarginBottom?: boolean;
  size?: "sm" | "md" | "lg";
  className?: HTMLAttributes<HTMLDivElement>["className"];
}

export const SectionTitle = (props: Props) => {
  const sizes = {
    sm: "text-sm",
    md: "text-base md:text-lg",
    lg: "text-base md:text-xl",
  };
  return (
    <section className={cn("grid grid-flow-row", !props.noMarginBottom && "mb-6", props.className)}>
      <h6 className={cn("font-semibold flex items-center gap-2", sizes[props.size ?? "md"])}>{props.title}</h6>
      {props.lead && <p className="text-xs md:text-sm text-black/50">{props.lead}</p>}
      {props.showDivider && <hr className={cn("border-t border-border", props.lead ? "mt-4" : "mt-2")} />}
    </section>
  );
};
